// import React from 'react';
// import './CardWork.scss';
// import { Button, Col, Row, Tag } from 'antd';
// import { HiMiniArrowUpRight } from 'react-icons/hi2';
// import { useNavigate } from 'react-router-dom';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import { useSelector } from 'react-redux';
// import img from '../../../assets/images/vr-for-medical 1.png';
// const CardWork = ({ t, data, slider, isLoading }) => {
//   const { currentLang } = useSelector((state) => state.user);
//   const navigate = useNavigate();
//   return (
//     <div className="card-work">
//       <div className="content">
//         <div
//           className={
//             slider
//               ? 'cards-our-work-responsive-none cards-our-work'
//               : 'cards-our-work'
//           }
//         >
//           <Row gutter={[30, 30]}>
//             {data?.map((item) => {
//               return (
//                 <Col sm={24} md={12} lg={12} xl={12} key={item?.id}>
//                   <div
//                     className="card-our-work"
//                     onClick={() =>
//                       navigate(
//                         `${currentLang === 'en' ? '' : '/ar'}/projects/${
//                           item?.id
//                         }`
//                       )
//                     }
//                   >
//                     <div
//                       className="img-card "
//                       style={{
//                         overflow: 'hidden',
//                       }}
//                     >
//                       <div className="overlay-img">
//                         <img
//                           src={item?.image}
//                           alt="Nature 1"
//                           style={{
//                             width: '100%',
//                             height: '100%',
//                             objectFit: 'cover',
//                           }}
//                         />
//                       </div>
//                       <div className="overlay-info">
//                         <p className="overlay-text">
//                           {/* {t.descriptionOurWork} */}
//                           {item?.summary}
//                         </p>
//                         <div
//                           className=""
//                           style={{
//                             width: '100%',
//                             display: 'flex',
//                             justifyContent: 'end',
//                             alignItems: 'end',
//                           }}
//                         >
//                           <Button
//                             type="text"
//                             style={{
//                               width: 'fit-content',
//                             }}
//                             icon={
//                               <HiMiniArrowUpRight size={20} color={'#3FE6FF'} />
//                             }
//                           />
//                         </div>
//                       </div>
//                     </div>
//                     <div className="content">
//                       <h3 className="title-card">{item?.title}</h3>
//                       <div className="card-tags">
//                         {item?.tags?.map((tag, index) => {
//                           return (
//                             <Tag className="tag-card" key={index}>
//                               {tag}
//                             </Tag>
//                           );
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                 </Col>
//               );
//             })}
//           </Row>
//         </div>
//         <div className="swiper-work-responsive">
//           {slider && (
//             <Swiper slidesPerView={1.1} spaceBetween={20}>
//               <div className="cards-our-work">
//                 <Row gutter={[30, 30]}>
//                   {data?.map((item) => {
//                     return (
//                       <SwiperSlide key={item?.id}>
//                         <Col sm={24} md={12} lg={12} xl={12} key={item?.id}>
//                           <div
//                             className="card-our-work"
//                             onClick={() =>
//                               navigate(
//                                 `${
//                                   currentLang === 'en' ? '' : '/ar'
//                                 }/projects/${item?.id}`
//                               )
//                             }
//                           >
//                             <div className={'img-card'}>
//                               <div className="overlay-img">
//                                 <img src={item?.image} alt="Nature 1" />
//                               </div>
//                               <div className="overlay-info">
//                                 <p className="overlay-text">{item?.summary}</p>
//                                 <div
//                                   className=""
//                                   style={{
//                                     width: '100%',
//                                     display: 'flex',
//                                     justifyContent: 'end',
//                                     alignItems: 'end',
//                                   }}
//                                 >
//                                   <Button
//                                     type="text"
//                                     style={{
//                                       width: 'fit-content',
//                                     }}
//                                     icon={
//                                       <HiMiniArrowUpRight
//                                         size={20}
//                                         color={'#3FE6FF'}
//                                       />
//                                     }
//                                   />
//                                 </div>
//                               </div>
//                             </div>
//                             <div className="content">
//                               <h3 className="title-card">{item?.title}</h3>
//                               <div className="card-tags">
//                                 {item?.tags?.map((tag, index) => {
//                                   return (
//                                     <Tag className="tag-card" key={index}>
//                                       {tag}
//                                     </Tag>
//                                   );
//                                 })}
//                               </div>
//                             </div>
//                           </div>
//                         </Col>
//                       </SwiperSlide>
//                     );
//                   })}
//                 </Row>
//               </div>
//             </Swiper>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CardWork;
import React from 'react';
import './CardWork.scss';
import { Button, Col, Row, Tag, Skeleton } from 'antd';
import { HiMiniArrowUpRight } from 'react-icons/hi2';
import { useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { useSelector } from 'react-redux';
// import img from '../../../assets/images/vr-for-medical 1.png';

const CardWork = ({ t, data, slider, isLoading }) => {
  const { currentLang } = useSelector((state) => state.user);
  const navigate = useNavigate();

  // Determine the number of skeleton cards to display
  const skeletonCount = 4; // Or any number you prefer

  const renderCards = (items) => {
    return items?.map((item) => (
      <Col sm={24} md={12} lg={12} xl={12} key={item?.id}>
        <div
          className="card-our-work"
          onClick={() =>
            navigate(
              `${currentLang === 'en' ? '' : '/ar'}/projects/${item?.id}`
            )
          }
        >
          <div
            className="img-card"
            style={{
              overflow: 'hidden',
            }}
          >
            <div className="overlay-img">
              <img
                src={item?.image}
                alt="Nature 1"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }}
              />
            </div>
            <div className="overlay-info">
              <p className="overlay-text">{item?.summary}</p>
              <div
                className=""
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'end',
                }}
              >
                <Button
                  type="text"
                  style={{
                    width: 'fit-content',
                  }}
                  icon={<HiMiniArrowUpRight size={20} color={'#3FE6FF'} />}
                />
              </div>
            </div>
          </div>
          <div className="content">
            <h3 className="title-card">{item?.title}</h3>
            <div className="card-tags">
              {item?.tags?.map((tag, index) => (
                <Tag className="tag-card" key={index}>
                  {tag}
                </Tag>
              ))}
            </div>
          </div>
        </div>
      </Col>
    ));
  };

  const renderSkeletonCards = () => {
    const skeletons = [];
    for (let i = 0; i < skeletonCount; i++) {
      skeletons.push(
        <Col sm={24} md={12} lg={12} xl={12} key={i}>
          <div className="card-our-work loading">
            <Skeleton.Image active style={{ width: '100%', height: '250px' }} />
            <div className="content" style={{ marginTop: '16px' }}>
              <Skeleton active paragraph={{ rows: 1 }} />
              <div className="card-tags" style={{ marginTop: '8px' }}>
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: '80px', marginRight: '8px' }}
                />
                <Skeleton.Button
                  active
                  size="small"
                  style={{ width: '60px' }}
                />
              </div>
            </div>
          </div>
        </Col>
      );
    }
    return skeletons;
  };

  return (
    <div className="card-work">
      <div className="content">
        <div
          className={
            slider
              ? 'cards-our-work-responsive-none cards-our-work'
              : 'cards-our-work'
          }
        >
          <Row gutter={[30, 30]}>
            {isLoading ? renderSkeletonCards() : renderCards(data)}
          </Row>
        </div>
        <div className="swiper-work-responsive">
          {slider && (
            <Swiper slidesPerView={1.1} spaceBetween={20}>
              <div className="cards-our-work">
                <Row gutter={[30, 30]}>
                  {isLoading
                    ? renderSkeletonCards().map((skeleton, index) => (
                        <SwiperSlide key={index}>{skeleton}</SwiperSlide>
                      ))
                    : data?.map((item) => (
                        <SwiperSlide key={item?.id}>
                          {/* The code for rendering a single card is repeated here, which can be refactored for better maintenance. */}
                          <Col sm={24} md={12} lg={12} xl={12} key={item?.id}>
                            <div
                              className="card-our-work"
                              onClick={() =>
                                navigate(
                                  `${
                                    currentLang === 'en' ? '' : '/ar'
                                  }/projects/${item?.id}`
                                )
                              }
                            >
                              <div className={'img-card'}>
                                <div className="overlay-img">
                                  <img src={item?.image} alt="Nature 1" />
                                </div>
                                <div className="overlay-info">
                                  <p className="overlay-text">
                                    {item?.summary}
                                  </p>
                                  <div
                                    className=""
                                    style={{
                                      width: '100%',
                                      display: 'flex',
                                      justifyContent: 'end',
                                      alignItems: 'end',
                                    }}
                                  >
                                    <Button
                                      type="text"
                                      style={{
                                        width: 'fit-content',
                                      }}
                                      icon={
                                        <HiMiniArrowUpRight
                                          size={20}
                                          color={'#3FE6FF'}
                                        />
                                      }
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="content">
                                <h3 className="title-card">{item?.title}</h3>
                                <div className="card-tags">
                                  {item?.tags?.map((tag, index) => (
                                    <Tag className="tag-card" key={index}>
                                      {tag}
                                    </Tag>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </SwiperSlide>
                      ))}
                </Row>
              </div>
            </Swiper>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardWork;
